import logo from '@/assets/brand/recepthor-logo.png';

// The dark brand pane every auth view shares (login, recover-password,
// activate-account). Styled by login.css: the split layout collapses it to a
// slim top banner on mobile.
export default function BrandPane() {
  return (
    <div className="login-brand">
      <img src={logo} alt="Recepthor Legaltech" className="login-logo" />
      <span className="login-tagline">Gestión judicial</span>
    </div>
  );
}
